var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgriculture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 34 34",
    style: {
      enableBackground: "new 0 0 34 34"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.2,1.8L29.2,1.8c0-0.4-0.3-0.6-0.7-0.6c-0.2,0-0.6,0.6-0.7,0.8c-0.2,0.3-0.5,0.6-0.8,0.9 c-0.6,0.5-1.3,1-2.1,1.2c-1.6,0.7-3.4,0.9-5.1,1.2c-0.9,0.1-1.8,0.3-2.7,0.5c-3.9,1-5.8,3.7-5.4,7.7c0.1,0.7,1.2,0.7,1.1,0 c-0.2-2.1,0-4.3,1.9-5.6c1.5-1,3.4-1.3,5.2-1.6c2.9-0.5,6.1-0.9,8.1-3c0.2,3.3,0.1,6.7-1.5,9.6c-2.4,4.5-8.2,4.4-12.3,2.4 c1.4-1.6,3-3.1,4.8-4.4c0.6-0.4,0-1.4-0.6-1c-4,3-7.5,6.5-8.7,11.4c-0.2,0.7,0.9,1,1.1,0.3c0.5-2,1.4-3.9,2.6-5.5 c4.3,2.2,10.1,2.4,13.3-1.7C29.7,11.1,29.6,6,29.2,1.8L29.2,1.8L29.2,1.8L29.2,1.8L29.2,1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.4,31.2h-3.1c-0.4,0-0.8,0.3-0.8,0.7c0,0.4,0.3,0.8,0.7,0.8h3.2c0.4,0,0.8-0.3,0.8-0.7 C16.2,31.6,15.9,31.3,15.4,31.2L15.4,31.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.9,28.9h-6.2c-0.4,0-0.8,0.3-0.8,0.7c0,0.4,0.3,0.8,0.7,0.8h6.3c0.4,0,0.8-0.4,0.7-0.8 C17.6,29.2,17.3,28.9,16.9,28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.5,11.5c0.8-0.7,1.7-1.3,2.7-1.7c0.1-0.6,0.3-1.2,0.6-1.8c-5,1.1-8.1,6.1-6.9,11.1C5.2,20.6,5.9,22,7,23.2 c0.2,0.4,0.7,0.4,1.1,0.2c0.4-0.2,0.4-0.7,0.2-1.1c0-0.1-0.1-0.1-0.2-0.2C5.3,19.1,5.5,14.4,8.5,11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.3,18.6c-0.3,1.3-0.9,2.6-1.8,3.6c-0.3,0.3-0.3,0.8,0,1.1c0.3,0.3,0.8,0.3,1.1,0c0,0,0.1-0.1,0.1-0.1 c1.2-1.4,2-3,2.3-4.9C22.4,18.5,21.8,18.5,21.3,18.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.5,24.2H9.1c-0.4,0-0.8,0.3-0.8,0.7c0,0.4,0.3,0.8,0.7,0.8h9.5c0.4,0,0.8-0.4,0.7-0.8 C19.2,24.5,18.9,24.2,18.5,24.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.5,26.6H9.1c-0.4,0-0.8,0.4-0.7,0.8c0,0.4,0.3,0.7,0.7,0.7h9.4c0.4,0,0.8-0.4,0.7-0.8 C19.2,26.9,18.9,26.6,18.5,26.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgriculture);
export default __webpack_public_path__ + "static/media/agriculture.e1bfd1703e07e85164ecc18af14eeb90.svg";
export { ForwardRef as ReactComponent };